import { render, staticRenderFns } from "./XlsMixin.vue?vue&type=template&id=32f6d164&scoped=true&"
import script from "./XlsMixin.vue?vue&type=script&lang=js&"
export * from "./XlsMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6d164",
  null
  
)

export default component.exports